import actions from '../utils/restActions';


const events = (state = {}, action) => {
    
    switch (action.type) {

    case actions.pages.index.status.success:

	return Object.assign({}, state, {list:  action.data});
 
    default:
	return state;
    }
}

export default events;



// WEBPACK FOOTER //
// ./src/reducers/Pages.js